import { useFormik } from "formik";
import React, { useEffect } from "react";
import * as Yup from "yup";
import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import TextInput from "../../common/textfield/TextInput";
import TextArea from "../../common/textfield/TextArea";
import { usePatientsBySOPQuery } from "../../../hooks/ReactQueryHooks/usePatientsBySOPQuery";
import { useScheduleCategoryQuery } from "../../../hooks/ReactQueryHooks/useScheduleCategoryQuery";
import SelectFiled from "../../common/textfield/SelectFiled";
import { Button } from "../../common/Button";
import { CircularProgress, Skeleton } from "@mui/material";
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import moment from "moment";
import { bookAppointment, checkSchedule, getSlots, rescheduleAppointment, getlistPractitioners } from "../api/AppointmentRequests";
import { getScheduleSlots, getSlotById, updateScheduleSlot} from "../../api/Schedule";
import { failed, success } from "../../common/Toastify";
import "../AppointmentRequests/style.css"
import { generatePass } from "../AppointmentRequests/Constants";
import { useSelector } from "react-redux";
import { getSignature } from "../../Zoom/functions";
import { updateAppointmentRequest } from '../api/AppointmentRequests';
import { Form } from "react-bootstrap";

const RescheduleAppointment = ({ modalShow, handleShow }) => {
    const user = useSelector((state) => state?.auth?.user);
    const [btnLoading, setBtnLoading] = useState(false);
    const [slotsLoading, setSlotsLoading] = useState(false);
    const [slotUnavailable, setSlotUnavailable] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [serviceCategory, setServiceCategory] = useState([]);
    const [categoriesByDay, setCategoriesByDay] = useState({});
    const [reservedCategories, setReservedCategories] = useState ({})
    const [practitionersList, setPractitionersList] = useState([]);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [availableDays, setAvailableDays] = useState([]);
    const userOrg = useSelector((state) => state?.auth?.user?.organizations)
    const userOrgId = userOrg?.[0]?.id;
    const preferredChannelType = modalShow?.intakeQuestions?.preferredChannel === "phone" || modalShow?.intakeQuestions?.preferredChannel === "Phone";
    const [fetchedSchedules, setFetchedSchedules] = useState([]);
    const [computedServiceCategories, setComputedServiceCategories] = useState([]);
   /* 
    useScheduleCategoryQuery({
        onSuccess: (data) => setServiceCategory(data.map((item) => ({
            name: `${item?.name} (${item?.timeSlot?.value} min)`,
            value: item.id,
            id: item.id,
            timeSlot: item.timeSlot,
        }))),
        refetchOnWindowFocus: false
    })
    */ 
    const formik = useFormik({
        initialValues: {
            title: "",
            patient: "",
            // description: "",
            date: "",
            serviceCategory: "",
            availableSlot: "",
            preferredChannel: modalShow?.intakeQuestions?.preferredChannel,
            returnTelephoneNumber: modalShow?.intakeQuestions?.callerNumber,
            returnTelephoneNumberExt: modalShow?.intakeQuestions?.callerNumberExt,
            practitionerPreference: modalShow?.practitionerId ? "select practitioner" : "",
            practitioner: modalShow?.practitionerId,
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Required Reason for visit field"),
            patient: Yup.string().required("Required Patient field"),
            // description: Yup.string().required("Required Description field"),
            date: Yup.string().required("Required Date field"),
            serviceCategory: Yup.string().required("Required Appointment type field"),
            practitioner: Yup.mixed().when(["practitionerPreference"], {
                is: (practitionerPreference) => practitionerPreference !== "no preference",
                then: Yup.string().required("Required Practitioner field."),
                otherwise: Yup.mixed().notRequired(),
            }),
            availableSlot: Yup.object().required("Required slots field"),
        }),
        onSubmit: (values) => {
            setBtnLoading(true);
            let slot = null;

            // let start =`${moment(values?.date)?.format("YYYY-MM-DD")}T${(values?.availableSlot?.start)}:00Z`;
            // let localStartTime = moment(start).format("HH:mm")
            // let localStart = `${moment(values?.date)?.format("YYYY-MM-DD")} ${(localStartTime)}`;
            // let utcStart = moment(localStart).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            // let end = `${moment(values?.date)?.format("YYYY-MM-DD")}T${(values?.availableSlot?.end)}:00Z`;
            // let localEndTime = moment(end).format("HH:mm")
            // let localEnd = `${moment(values?.date)?.format("YYYY-MM-DD")} ${(localEndTime)}`;
            // let utcEnd = moment(localEnd).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
            let utcStart = values?.availableSlot?.start;
            let utcEnd = values?.availableSlot?.end;
            let reserved = values?.availableSlot?.status == "busy-reserved"
            let selectedServiceCategory = values?.serviceCategory;
            let intakeQuestions =modalShow?.intakeQuestions;
            intakeQuestions["preferredChannel"] = values?.preferredChannel;


            // if(selectedServiceCategory.endsWith("busyReserved")){
            //     selectedServiceCategory = selectedServiceCategory.split("-")?.[0];
            // }
            
            // this filter returns an object as a REFERENCE, so you need to structuredClone the resulting value if there is one
            selectedServiceCategory = serviceCategory?.filter((categoryData) => categoryData.value === selectedServiceCategory)?.[0]
            if(reserved) {
                selectedServiceCategory = structuredClone(selectedServiceCategory);
                selectedServiceCategory.id = selectedServiceCategory?.value?.split("-")[0];
                selectedServiceCategory.name = selectedServiceCategory.name.trim();
            }
            let serviceCategoryPayload = [
                {
                  coding: [
                    {
                      system: "http://florizel.com/AppointmentServiceCategory",
                      code: selectedServiceCategory?.id,
                      display: selectedServiceCategory?.display ? selectedServiceCategory?.display : selectedServiceCategory?.name
                    }
                  ],
                  text: `Appointment for ${selectedServiceCategory?.display ? selectedServiceCategory?.display : selectedServiceCategory?.name}`
                }
            ]
            /* if(values?.availableSlot.status === "busy-reserved"){
                utcStart= values?.availableSlot?.start
                utcEnd = values?.availableSlot?.end
                slot = values?.availableSlot;
            }
            else */ if(formik?.values?.practitionerPreference === "no preference") {
                values.practitioner = values?.availableSlot?.actorId;
                values.scheduleId = values?.availableSlot?.scheduleId;
            }
            else values.scheduleId = values?.availableSlot?.scheduleId;
            
            const requestedPeriod = [{start: utcStart, end: utcEnd}];
            let keepOldSlot = false;
            getSlotById(modalShow?.slotId)
            .then((response) =>{
            let data = response?.data?.[0]
            // if(data?.serviceCategory?.[0]?.id){
            //     keepOldSlot = true;
            // }
            rescheduleAppointment({serviceCategory: serviceCategoryPayload, intakeQuestions, keepOldSlot: false, slot,  appointmentId: modalShow?.id,  requestedPeriod , practitionerId:  values?.practitioner, scheduleId: values?.scheduleId, description: values?.title })
                .then((res) => {
                    success("Appointment Rescheduled");
                    if(keepOldSlot){
                        updateScheduleSlot({
                            slotId : data?.id,
                            start: data?.start,
                            end: data?.end,
                            status: "busy-reserved",
                            serviceCategories: data?.serviceCategory
                        })
                        .catch(()=>{})
                    }
                    handleShow();

                })
                .catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
                .finally(() => setBtnLoading(false));
            })
            
            .catch(() => {})
        },
    });
    
    useEffect(() => {
        if (modalShow?.id) {
            formik.setFieldValue("title",  modalShow.description);
            formik.setFieldValue("patient", modalShow.participant?.filter((data) => data?.actor?.type === "Patient")?.[0]?.actor?.display) ;
            formik.setFieldValue("description", modalShow.comment || "");
            formik.setFieldValue("returnTelephoneNumber", modalShow?.intakeQuestions?.callerNumber || "");
            formik.setFieldValue("returnTelephoneNumberExt", modalShow?.intakeQuestions?.callerNumberExt || "");
            formik.setFieldValue("practitioner", modalShow?.practitionerId || "");
            formik.setFieldValue("preferredChannel", modalShow?.intakeQuestions?.preferredChannel || "");           
        }
    }, [modalShow])

    useEffect(() => {
        if (modalShow?.practitionerId) {
            let scopeOfPractice
            if(modalShow?.patientLocation)
                scopeOfPractice = modalShow?.patientLocation
            else{
                let temp = modalShow?.intakeQuestions?.filter(el => el.tag === "LOCATION")[0].answer.find((val) => val.answer.length > 0).answer;
                scopeOfPractice = temp;
            }
            getlistPractitioners({orgId: user?.organizations[0]?.id , scopeOfPractice})
                .then(async (res) => {
                    let allPracts = res.result?.filter(pra => pra.active);
                    let activePractitioners = [];
                    let startDate = (formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : moment();
                    startDate = moment(startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
                        
                    await checkSchedule({actorId: user["custom:unique_id"], date: startDate, orgId: user?.organizations[0]?.id })
                        .then((activeSchedules)=> {
                            if(!activeSchedules?.data) { 
                                // no active schedules, so list no practitioners
                                failed(activeSchedules?.message);
                                setServiceCategory([]);
                                setCategoriesByDay({});
                                setPractitionersList([]);
                                return;
                            }
                            if(!Array.isArray(activeSchedules.data)) 
                                activeSchedules.data = [activeSchedules.data];
                            
                            // remove empty schedules
                            activeSchedules.data = activeSchedules.data.filter(sch => {
                                return sch.orgId === user?.organizations[0]?.id 
                                    && sch.serviceCategory?.length > 0 
                                    && sch.serviceCategory.filter(cat => moment(cat.date).isSameOrAfter(moment(startDate), "day")).length > 0
                            })
                            
                            activeSchedules.data.forEach(schedule => {
                                let active = allPracts.find(person => person.id === schedule.actorId && !activePractitioners.some(exists => exists.id === schedule.actorId))
                                if(active) 
                                    activePractitioners.push(active);
                            })
                            // practitioners that have active schedules for the current month.
                            setPractitionersList(activePractitioners.map(ele => (
                                { 
                                    value: ele?.id, 
                                    name: ele?.name?.[0]?.text?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), // capitalize all names, surname, given name, etc.
                                    id: ele?.id 
                                }
                            ))) 
                        })                
                        .catch((activeSchedules) => {
                            failed(activeSchedules?.response?.data?.message || activeSchedules?.response?.data?.error || activeSchedules.message);
                            setServiceCategory([]);
                            setCategoriesByDay({});
                            setPractitionersList([]);
                        });            
                    })
                .catch((res) => {
                        failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                })
        }
    }, [modalShow])
   
    
    useEffect(() => {
        let startLocal = (formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : moment();
        let today = new Date();
        let startValue = startLocal.valueOf()
        let startDate = startLocal.utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
        // if (formik?.values?.date) {
        let start = startLocal.format("YYYY-MM-DD");
        if(formik?.values?.practitionerPreference &&
            ((formik?.values?.practitionerPreference === "select practitioner" && formik?.values?.practitioner)
               || formik?.values?.practitionerPreference === "no preference" )){
                checkSchedule({ actorId: formik?.values?.practitioner ? formik.values.practitioner:  user["custom:unique_id"], date: startDate, orgId: formik?.values?.practitionerPreference === "no preference" ? user?.organizations[0]?.id : null }) 
            .then((res) => { 
                if(!res?.data) {
                   failed(res?.message);
                   setServiceCategory([]);
                   setCategoriesByDay({});
                   return;
                }
                
                let categories = [];
                if (!Array.isArray(res.data)) res.data = [res.data];
                
                // remove any schedules from different organizations than the current user's 
                res.data = res.data.filter(sch => sch.orgId == user?.organizations[0]?.id)
                setFetchedSchedules(res.data);
                let tempByDay = {};
                res.data.forEach(schedule => {                
                    schedule.serviceCategory.forEach(category => {
                        if(category.id) { // occasional bad data where there is a date and no id, so do not process
                            let key = moment(category?.date).format("YYYY-MM-DD");
                            let catTimestamp = moment(category?.date).valueOf();
                            if(moment(catTimestamp).isSameOrAfter(moment(startValue), "day") && 
                                !categories.some(item => item.value === category.id)) {
                                categories.push({...category, value: category?.id});                                
                            }
                            if(moment(catTimestamp).isSameOrAfter(moment(startValue), "day")) {
                                if(tempByDay[key]) {
                                    if(!tempByDay[key].some(id => id === category.id )) 
                                        tempByDay[key].push(category.id)
                                    }
                                else tempByDay[key] = [category.id];   
                            }
                        }
                    })
                
            })
            setCategoriesByDay(merge(categoriesByDay, tempByDay))
            let reservedSlots ={}
            let newData = [];
            res.data.forEach(schedule => 
                getScheduleSlots(schedule.id, "busy-reserved", userOrgId)
                .then((resp) => {
                    resp.data?.filter((slot)=> moment(slot?.start).isSameOrAfter(moment(start), "day"))
                    ?.map((slot) => {
                        slot.serviceCategory?.forEach(cat => {
                            let serviceCategoryId = cat.id || cat.coding[0].code;
                            if (reservedSlots.hasOwnProperty(serviceCategoryId)) {
                                reservedSlots[serviceCategoryId].push({
                                    "start": slot?.start,
                                    "end": slot?.end,
                                    "serviceCategory": [cat],
                                    "scheduleId": slot?.scheduleId,
                                    "actorId": schedule.actorId,
                                    "orgId": slot?.orgId,
                                    "status": "busy-reserved"
                                });
                            }    
                            else {
                                reservedSlots[serviceCategoryId] = [{
                                    "start": slot?.start,
                                    "end": slot?.end,
                                    "serviceCategory": [cat],
                                    "scheduleId": slot?.scheduleId,
                                    "actorId": schedule.actorId,
                                    "status": "busy-reserved"
                                }];
                            }
                        })
                    })
                    if(Array.isArray(reservedSlots))
                        if(moment(startLocal).isSame(moment(today), "day")) {
                            reservedSlots = removeLateSlots(removePastSlots(reservedSlots), moment(startLocal).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z");
                        }
                        else {
                            reservedSlots = removeLateSlots(removeSlotsOutsideOfDayRange(removePastSlots(reservedSlots), moment(startLocal).utc()), moment(startLocal).utc())
                        }
                    else {
                        Object.keys(reservedSlots).forEach(key => {
                            if(moment(startLocal).isSame(moment(today), "day")) {
                                reservedSlots[key] = removeLateSlots(removePastSlots(reservedSlots[key]), moment(startLocal).utc())
                            }
                            else {
                                reservedSlots[key] = removeLateSlots(removeSlotsOutsideOfDayRange(removePastSlots(reservedSlots[key]), moment(startLocal).utc()), moment(startLocal).utc())
                            }
                        })
                    }
                    Object.keys(reservedSlots).forEach(key => {
                        if(reservedSlots[key].length > 0 
                            && (reservedSlots[key][0]?.serviceCategory?.[0]?.id || reservedSlots[key][0]?.serviceCategory?.[0].coding[0]?.code)) {
                            // && !newData.some(item => item.value === `${reservedSlots[key][0]?.serviceCategory?.[0]?.id}-busyReserved`)) {
                            // console.log("RESERVED SLOT KEY", key)
                            // newData.push({
                            //     name: `Reserved for ${reservedSlots[key]?.[0]?.serviceCategory[0]?.name}`,
                            //     value: `${reservedSlots[key][0]?.serviceCategory?.[0]?.id}-busyReserved`,
                            //     status: "busy-reserved"
                            // });
                            if(moment(reservedSlots[key][0]?.start).isSameOrAfter(startValue, "day") && 
                                !categories.some(item => item.value === key)) {
                                let timeSlot = reservedSlots[key][0]?.serviceCategory?.[0]?.timeSlot;
                                if(!timeSlot) {
                                    // slot is in a different format, so you need to parse the description to get the timeslot.
                                    let timeSlotString = reservedSlots[key]?.[0]?.serviceCategory[0]?.coding[0]?.display.split("(")[1].split(")")[0].split(" ");
                                    // this should be an array of number and unit now.
                                    timeSlot = { 
                                        value: parseInt(timeSlotString[0]),
                                        unit: 'minutes'
                                    };
                                }
                                let name = (reservedSlots[key]?.[0]?.serviceCategory[0]?.name || reservedSlots[key]?.[0]?.serviceCategory[0]?.coding[0]?.display);
                                let value = (reservedSlots[key][0]?.serviceCategory?.[0]?.id || reservedSlots[key][0]?.serviceCategory?.[0].coding[0]?.code);
                                categories.push({
                                    name, 
                                    value,
                                    timeSlot,
                                    date: reservedSlots[key][0]?.start
                                })
                            }
                            // ADD TO CATEGORIES BY DAY HERE
                            tempByDay = {};
                            if(reservedSlots[key].length > 0) {
                                reservedSlots[key].forEach(slot => {
                                    let datekey = moment(slot?.start).format("YYYY-MM-DD");
                                    let startTimestamp  = moment(slot?.start).valueOf();
                                    
                                    if(moment(startTimestamp).isSameOrAfter(moment(startValue), "day")) {
                                        if(tempByDay[datekey] && !tempByDay[datekey]?.some(id => id === key)) {
                                                tempByDay[datekey].push(key);
                                        }
                                        else tempByDay[datekey] = [key];
                                    }
                                })
                            }
                            setCategoriesByDay(merge(categoriesByDay, tempByDay)) 
                        }
                    });
                    setReservedCategories(reservedSlots);
                    setServiceCategory([...categories])
                })
                .catch((res) => {
                    failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                        setServiceCategory([]);
                        setCategoriesByDay({});
                    })
                );
            })
            .catch((res) => {
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                setServiceCategory([]);
                setCategoriesByDay({});
            });
        }
    }, [modalShow?.id, formik?.values?.practitioner, formik?.values?.practitionerPreference])


    const loadSlotData = (selectedDate, selectedType) => {
        setSlotsLoading(true);
        let today = new Date();
        let date = (selectedDate) ? selectedDate : formik?.values?.date;
        let type = (selectedType) ? selectedType : formik?.values?.serviceCategory;
        date = moment(date).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z"
        /* if(type?.endsWith("busyReserved")){
            let currentTime = moment(date);
            let slots = reservedCategories[type.split("-")[0]];
            slots = slots?.filter(slot => moment(slot.start).isAfter(currentTime) && moment(slot.start).isSame(currentTime, "day"))
            slots = sortedSlots(slots);
            if (slots.length < 1) {
                setSlotUnavailable(true)
            }
            setAvailableSlots(slots)
            setSlotsLoading(false)
        } else */ 
        if(type) {
            /** grab reserved slots first  */
            let currentTime = moment(date);
            let slots = reservedCategories[type];
            slots = slots?.filter(slot => moment(slot.start).isAfter(currentTime) && moment(slot.start).isSame(currentTime, "day"))
            slots = sortedSlots(slots);
            //setAvailableSlots(slots);
            /** retrieve all slots here */
            let params = { actorId: formik?.values?.practitioner || user["custom:unique_id"], date, serviceCategoryId: type, orgId: formik?.values?.practitionerPreference === "no preference" ? user?.organizations[0]?.id : userOrgId }
            if(formik?.values?.practitionerPreference === "no preference") {
                if(modalShow?.patientLocation)
                    params.scopeOfPractice = modalShow?.patientLocation
                else{
                    let temp = modalShow?.intakeQuestions?.filter(el => el.tag === "LOCATION")[0].answer.find((val) => val.answer.length > 0).answer;
                    params.scopeOfPractice = temp;
                }
            }
            getSlots(params)
                .then((res) => {
                    // remove early slots
                    let currentSlots = [];
                    if(moment(date).isSame(moment(today), "day")) {
                        currentSlots = removeLateSlots(removePastSlots(res?.data?.availableSlots), moment(date).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z");
                    }
                    else {
                        currentSlots = removeLateSlots(removeSlotsOutsideOfDayRange(res.data?.availableSlots, moment(date).utc()), moment(date).utc());
                    }
                    currentSlots = sortedSlots(currentSlots);
                    if(slots?.length > 0) {
                        // merge reserved and currentSlots removing duplicate timeslots
                        slots.forEach(slot => {
                            let found = currentSlots.filter(item => item.start == slot.start);
                            if(found.length > 0) 
                                found = slot;
                            else 
                                currentSlots.push(slot);
                        })
                    }
                    currentSlots = sortedSlots(currentSlots)
                    setAvailableSlots(currentSlots)
                    if (currentSlots < 1) {
                        setSlotUnavailable(true)
                }
                }).catch((res) => {
                    if(slots?.length > 0) {
                        setAvailableSlots(sortedSlots(slots));
                    }
                    else {
                        failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                        setAvailableSlots([])
                    }
                }).finally(() => { setSlotsLoading(false) })
        }
        else setSlotsLoading(false);  
    } 

    const handleDateSelection = (val) => {
        const isValidDate = moment(val, 'MMM-DD-YYYY').isValid()
        setAvailableSlots([])
        if(isValidDate){
            formik.setFieldValue("date", val.format("YYYY-MM-DD"));
            // load slots here
            loadSlotData(val.format("YYYY-MM-DD"))
        }else{
            formik.setFieldError('date', 'Invalid date format')
        }       
    }    

    const removeLateSlots = (slots, date) => {
        let midnight = (date) ? new Date(date) : new Date();
        // console.log("DATE", midnight) // date before processing
        midnight = new Date(midnight.setDate(midnight.getDate()+1));
        midnight.setHours(0)
        midnight.setMinutes(0)
        midnight.setSeconds(0);
        // console.log("REMOVE LATE SLOTS MIDNIGHT: ", midnight); // midnight of submitted date.
        if(Array.isArray(slots)) {
            // console.log("slot count", slots.length)
            const filteredSlots = slots.filter(slot => {
                // console.log("SLOT END", slot.end)
                let endTime = new Date(slot.end).getTime();
                let midnightTime = midnight.getTime();
                // console.log(endTime < midnightTime, slot.start)
                return (endTime < midnightTime)
            })
            // console.log("slot count after filter", filteredSlots.length)
            //setOrgSlotsData(filteredSlots);
            return filteredSlots;
        }
        else return slots;        
    }

    function removeSlotsOutsideOfDayRange(slots, date) {
        let midnight = (date) ? new Date(date) : new Date();
        midnight = new Date(midnight.setDate(midnight.getDate()));
        midnight.setHours(0)
        midnight.setMinutes(0)
        midnight.setSeconds(0);
        // console.log("REMOVE OUTSIDE DAY RANGE MIDNIGHT: ", midnight); // start of submitted day, localtime.
        if(Array.isArray(slots)) {
            // console.log("slot count", slots.length)
            const filteredSlots = slots.filter(slot => {
                // console.log("SLOT START", slot.start)
                let startTime = new Date(slot.start).getTime();
                let midnightTime = midnight.getTime();
                // console.log(startTime > midnightTime, slot.start)
                return (startTime > midnightTime)
            })
            // console.log("slot count after filter", filteredSlots.length)
            //setOrgSlotsData(filteredSlots);
            return filteredSlots;
        }
        else return slots;
    }

    const removePastSlots = (slots) => {
        let now = new Date().getTime();
        if(Array.isArray(slots))
            return slots?.filter(slot => new Date(slot.start).getTime() > now);
        else return slots
    }

    /** sorts slots based on time */
    const sortedSlots = (data) => {      
        return data?.sort((a,b) => {
            let atime = (moment(a.start).isValid()) ? `${a.start}`:`${moment(formik.values.date)?.format("YYYY-MM-DD")}T${a?.start}:00Z`;
            let btime = (moment(b.start).isValid()) ? `${b.start}`:`${moment(formik.values.date)?.format("YYYY-MM-DD")}T${b?.start}:00Z`;
            return (new Date(atime).getTime() < new Date(btime).getTime()) ? -1 : 1;           
        })
    }

    const sortedObj = data => {
        return data.sort((a,b) => {
            return a.name > b.name ? 1 : -1
        });
    }

    /***
     * merge is used to merge 2 objects.  Previously used Object.assign and it would
     * cause data lose, so this is a better method for the categories by day which
     * modifies the obj1 with data from obj2.
     */
    const merge = (obj1, obj2) => {
        for(let key in obj2) {
            if(obj1[key]) {
                // if both elements contain an array, then extend the array
                if(Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
                    obj2[key].forEach(cat => {
                        if(!obj1[key].includes[cat])
                            obj1[key].push(cat);
                    })
                }
                else {
                    // else replace the value with matching obj2
                    obj1[key] = obj2[key]
                }
            }
            else 
                obj1[key] = obj2[key];
        }
        return obj1;
    }

    const findUpcoming = (event) => {
        setSlotUnavailable(false);        
        let targetVal = event?.target?.value;
        formik.setFieldValue("serviceCategory", targetVal);
        setAvailableSlots([])
        formik.setFieldValue("date", "");
    }

    const renderDay = (props) => {
        const { selectedDate, day, dayComponent, ...other} = props;
        const today = moment();
        const isAvailable = availableDays.includes(day.format("YYYY-MM-DD"));
        const isSelected = day.isSame(selectedDate, "day");
        const isToday = day.isSame(today, "day");
        const isPast = day.isBefore(today, "day")

        return (
            <PickersDay {...dayComponent} 
                disabled={isPast || !isAvailable}
                style={isAvailable ? {background: "#accfeb"}: {background: "white" }} />
        );
    }

    const handlePractitionerPreferenceChange = (e) => {
        formik.setFieldValue("practitioner", "");
        formik.setFieldValue("serviceCategory", ""); 
        formik.setFieldValue("date", "");
        setServiceCategory([]);
        setAvailableSlots([]);
        setCategoriesByDay([]);
        formik.setFieldValue("practitionerPreference", e.target.id);
    };
    
    const handlePractitionerChange = (event) => {   
        formik.setFieldValue("practitioner", event?.target?.value );
        formik.setFieldValue("serviceCategory", ""); 
        formik.setFieldValue("date", "");
        setServiceCategory([]);
        setAvailableSlots([]);
        setCategoriesByDay([]);
    }


    const highLightDates = () => {
        setAvailableDays([]);
        const today = moment();
        const now = moment();
        const toHighlight = [];

        const foundCategory = serviceCategory.find(
            (item) => (item.id || item.value) === formik.values.serviceCategory
        );

        if (!foundCategory || !foundCategory.timeSlot) {
            setAvailableDays([]);
            return;
        }

        const timeSlot = parseInt(foundCategory.timeSlot.value, 10);
        const availabilities = computedServiceCategories?.[formik.values.serviceCategory] || [];

        availabilities.forEach((period) => {
            let periodStart = moment(period.start);
            let periodEnd = moment(period.end);

            // Only consider today or future days
            if (periodStart.isBefore(today, "day")) return;

            // Adjust current period if it’s today
            if (periodStart.isSame(today, "day")) {
            if (periodEnd.isBefore(now)) return;
            if (periodStart.isBefore(now)) periodStart = now.clone();
            }

            const availableMinutes = periodEnd.diff(periodStart, "minutes");
            if (availableMinutes >= timeSlot) {
            const dayKey = periodStart.format("YYYY-MM-DD");
            if (!toHighlight.includes(dayKey)) {
                toHighlight.push(dayKey);
            }
            }
        });

        setAvailableDays(toHighlight);
    };


    const fetchSchedules = async () => {
        const schedulesWithSlots = await Promise.all(
            fetchedSchedules.map(async (schedule) => {
            const slotsResponse = await getScheduleSlots(schedule.id);
            const slots = slotsResponse.data || [];
            return { ...schedule, slots };
            })
        );

        const result = computeServiceCategoryAvailabilities(schedulesWithSlots);
        setComputedServiceCategories(result);
    };


    const computeServiceCategoryAvailabilities = (schedules) => {
        const busyStatuses = [
            "busy-meeting", "busy-unavailable", "busy-training", "busy-documentation",
            "busy-meal", "busy-administration", "busy-unscheduled", "busy-break", "busy-other",
        ];

        // Removes a busy period from available blocks
        const subtractTimePeriod = (availabilityPeriods, slotStart, slotEnd) => {
            const updated = [];

            for (const period of availabilityPeriods) {
            if (slotEnd <= period.start || slotStart >= period.end) {
                updated.push(period); // no overlap
            } else {
                if (slotStart > period.start) {
                updated.push({ start: period.start, end: slotStart }); // before busy time
                }
                if (slotEnd < period.end) {
                updated.push({ start: slotEnd, end: period.end }); // after busy time
                }
            }
            }

            return updated;
        };

        // Adds a new reserved time block
        const insertTimePeriod = (availabilityPeriods, slotStart, slotEnd) => {
            return [...availabilityPeriods, { start: slotStart, end: slotEnd }];
        };

        // Merges overlapping or adjacent time blocks
        const mergeTimePeriods = (periods) => {
            if (!periods.length) return [];

            periods.sort((a, b) => a.start - b.start);
            const merged = [periods[0]];

            for (let i = 1; i < periods.length; i++) {
            const last = merged[merged.length - 1];
            const current = periods[i];

            if (current.start <= last.end) {
                last.end = new Date(Math.max(last.end, current.end)); // merge
            } else {
                merged.push(current);
            }
            }

            return merged;
        };

        const serviceCategoryAvailabilities = {};
        const allServiceCategories = {};

        for (const schedule of schedules) {
            const planningStart = new Date(schedule.planningHorizon.start);
            const planningEnd = new Date(schedule.planningHorizon.end);

            // Step 1: Add initial availability per service category
            for (const sc of schedule.serviceCategory || []) {
            const scId = sc.id;
            const scName = sc.name;
            const scDate = new Date(sc.date);

            const y = scDate.getFullYear();
            const m = scDate.getMonth();
            const d = scDate.getDate();

            const dayStart = new Date(y, m, d, planningStart.getHours(), planningStart.getMinutes());
            const dayEnd = new Date(y, m, d, planningEnd.getHours(), planningEnd.getMinutes());

            // Clamp dayStart and dayEnd within planning horizon
            if (dayStart < planningStart && planningStart.toDateString() === dayStart.toDateString()) {
                dayStart.setHours(planningStart.getHours(), planningStart.getMinutes());
            }
            if (dayEnd > planningEnd && planningEnd.toDateString() === dayEnd.toDateString()) {
                dayEnd.setHours(planningEnd.getHours(), planningEnd.getMinutes());
            }

            if (dayStart >= dayEnd) continue;

            if (!allServiceCategories[scId]) {
                allServiceCategories[scId] = { id: scId, name: scName };
            }

            if (!serviceCategoryAvailabilities[scId]) {
                serviceCategoryAvailabilities[scId] = [];
            }

            serviceCategoryAvailabilities[scId].push({ start: dayStart, end: dayEnd });
            }

            // Step 2: Apply slots to subtract or insert busy times
            for (const slot of schedule.slots || []) {
            const slotStart = new Date(slot.start);
            const slotEnd = new Date(slot.end);
            const slotStatus = slot.status;
            const slotServiceCategories = slot.serviceCategory || [];

            const scTypes = slotServiceCategories.map((item) =>
                item?.id
                ? { id: item.id, name: item.name }
                : { id: item?.coding?.[0]?.code, name: item?.coding?.[0]?.display }
            );

            if (slotStatus === "busy-reserved") {
                // Reserved time should be removed from *other* categories
                for (const scId in serviceCategoryAvailabilities) {
                if (!scTypes.find((s) => s.id === scId)) {
                    serviceCategoryAvailabilities[scId] = subtractTimePeriod(
                    serviceCategoryAvailabilities[scId],
                    slotStart,
                    slotEnd
                    );
                }
                }

                // But added to the reserved category
                for (const sc of scTypes) {
                allServiceCategories[sc.id] = allServiceCategories[sc.id] || sc;
                serviceCategoryAvailabilities[sc.id] = insertTimePeriod(
                    serviceCategoryAvailabilities[sc.id] || [],
                    slotStart,
                    slotEnd
                );
                }
            } else if (busyStatuses.includes(slotStatus)) {
                // Generic busy time blocks availability for all categories
                for (const scId in serviceCategoryAvailabilities) {
                serviceCategoryAvailabilities[scId] = subtractTimePeriod(
                    serviceCategoryAvailabilities[scId],
                    slotStart,
                    slotEnd
                );
                }
            }
            }
        }

        // Step 3: Merge overlapping time periods per category
        for (const scId in serviceCategoryAvailabilities) {
            serviceCategoryAvailabilities[scId] = mergeTimePeriods(serviceCategoryAvailabilities[scId]);
        }

        return serviceCategoryAvailabilities;
    };

    useEffect(() => {
        if(fetchedSchedules.length > 0 && formik?.values?.practitionerPreference) {
            fetchSchedules()
        }
    }, [fetchedSchedules, formik?.values?.practitionerPreference]);
    return (
        <Modal
            backdropClassName
            backdrop={'static'}
            size="xl" show={modalShow} onHide={handleShow}
            aria-labelledby="contained-modal-title-vcenter"
            centered className="custom-dialog">
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">
                    Rescheduling Appointment
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                    
                    <>
                        <Row>
                            <Col>
                                <TextInput keyField={"title"} label={"Reason for visit"} formik={formik} placeholder={"Reason for visit"} />
                            </Col>
                            <Col>
                                <TextInput disabled = {true} keyField={"patient"} label={"Patient Name"} formik={formik} placeholder={"Patient Name"} style={{textTransform: "capitalize"}}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Check.Label style={{ textTransform: "capitalize", fontSize: "14px" }} >{"practitioner preference ?"}</Form.Check.Label> <span className="requiredField">&#42;</span><br/>
                                {["select practitioner", "no preference"].map((val) => (
                                    <Form.Check style={{ textTransform: "capitalize", fontSize: "14px", marginRight: "45px"}} inline checked={formik.values.practitionerPreference === val} type={"radio"} label={val} id={val} name="practitioner preference"  onChange={handlePractitionerPreferenceChange} />
                                    ))}
                                    {formik?.touched["practitionerPreference"] && formik?.errors["practitionerPreference"] ? (<div className="error-text">{formik?.errors["practitionerPreference"]} </div>) : null}
                            </Col>
                            {formik?.values?.practitionerPreference === "select practitioner" ? (
                                <Col>
                                    <SelectFiled keyField={"practitioner"} label={"Select Practitioner"} formik={formik} options={sortedObj(practitionersList)} onChange={handlePractitionerChange} />
                                </Col>
                            ) : <Col></Col>}
                                
                        </Row>
                        <Row className="mt-3">
                            <Col>
                                <SelectFiled keyField={"serviceCategory"} label={"Appointment Type"} formik={formik} options={sortedObj(serviceCategory)} disabled={!formik.values.practitionerPreference} onChange={findUpcoming} />
                            </Col>
                            <Col>
                                <DateSelectorWithoutFormik disabled={!formik?.values?.serviceCategory} formik={formik} keyField={'date'} label="Date" value={(formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : null} handleChange={(value) => { handleDateSelection(value)}} minDate={moment()} defaultValue={moment()} onMonthChange={highLightDates} onOpen={highLightDates} renderDay={(day, selectedDate, dayComponent) => renderDay({day, selectedDate, dayComponent})} />
                            </Col>
                        </Row>
                        {availableSlots?.length > 0 ?
                                <>
                                    <Row>
                                        <Col>Select Slot</Col>
                                    </Row>
                                    <Row style={{/*  justifyContent: "center", */ rowGap: "0.5rem", marginBottom: "1.5rem", marginTop: "0.5rem" }}>
                                        {availableSlots?.map((slot, index) => {
                                        let localTime = moment(slot?.start).format("HH:mm");
                                        
                                        return ( <Col style={{ background: selectedSlot === slot?.start ? "#6c757d38" : "#ffff", width: "14.666667%" }} sm={2} className="slotStyle" key={index} onClick={() => { formik?.setFieldValue("availableSlot", slot); setSelectedSlot(slot?.start) }}>{localTime}</Col>)
                                        })}
                                    </Row>
                                </>
                                : null}
                        {slotsLoading ?
                            <>
                                <Row>
                                    <Col>Select Slot</Col>
                                </Row>
                                <Skeleton height={50} />
                            </>
                            : null}
                        <Row>
                            {/* <Col>
                                <TextArea keyField={"description"} label={"Description"} formik={formik} placeholder={"Description"} />
                            </Col> */}
                            {modalShow?.intakeQuestions?.preferredChannel && (
                              <Col>
                                <Form.Check.Label style={{ textTransform: "capitalize", fontSize: "14px" }} >{"preferred channel ?"}</Form.Check.Label> <span className="requiredField">&#42;</span><br/>
                                {["phone", "video/chat"].map((val) => (
                                    <Form.Check style={{ textTransform: "capitalize", fontSize: "14px", marginRight: "65px"}} inline checked={formik.values.preferredChannel === val} type={"radio"} label={val} id={val} name="preferred channel" onChange={e => formik.setFieldValue("preferredChannel", e.target.id)} />
                                ))}
                            </Col>  
                            )}
                            
                            {modalShow?.intakeQuestions?.callerNumber && (
                              <Col>
                                <Row>
                                    <Col>
                                        <TextInput keyField={"returnTelephoneNumber"} type="phone" label={"Return Telephone Number"} formik={formik} disabled={true} placeholder={"Return Telephone Number"} required={true} />
                                    </Col>
                                    <Col>
                                        <TextInput keyField={"returnTelephoneNumberExt"} label={"Ext."} formik={formik} disabled={true} placeholder={"Ext."} required={false} />
                                    </Col>
                                </Row>
                            </Col>  
                            )}
                        </Row>
                    </>
                    
                    <div className="btn-wrap">
                        <Button
                            onClick={() => {
                                handleShow();
                            }}
                            variant="secondary"
                            title="Cancel"
                        >
                            Cancel
                        </Button>
                        <Button type="submit" isLoading={btnLoading}>
                            Done
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default RescheduleAppointment;
